<button type="button" (click)="onClose()" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
    <path data-name="iconfinder_remove-01_186389"
      d="M11.211,9.853l2.815-2.814a1.065,1.065,0,0,0,0-1.5l-.375-.375a1.063,1.063,0,0,0-1.5,0L9.335,7.977,6.52,5.162a1.064,1.064,0,0,0-1.5,0l-.375.375a1.065,1.065,0,0,0,0,1.5L7.458,9.853,4.644,12.667a1.065,1.065,0,0,0,0,1.5l.375.375a1.064,1.064,0,0,0,1.5,0l2.815-2.814,2.815,2.814a1.064,1.064,0,0,0,1.5,0l.375-.375a1.065,1.065,0,0,0,0-1.5Z"
      transform="translate(-4.334 -4.853)" fill="#dbdbdb" />
  </svg>
</button>
<div class="modal-header">
  <h6 class="modal-title">{{options.title}}</h6>
</div>
<div class="modal-body">
  <div class="main-form">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="form-group">
          <input [accept]="options.accept" type="file" multiple class="form-control" (change)="onFileChange($event)" />
          <div class="content-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="59.113" height="38.001" viewBox="0 0 59.113 38.001">
              <path id="iconfinder_icon-upload_211937"
                d="M80.307,127.992c0-.158.026-.317.026-.475A15.389,15.389,0,0,0,65.067,112,15.219,15.219,0,0,0,51.3,120.841a7.817,7.817,0,0,0-3.536-.858,7.917,7.917,0,0,0-7.759,6.663A12.023,12.023,0,0,0,43.809,150H57.334V139.445h-6.36L61.557,128.4l10.582,11.031h-6.36v10.556H80.333a11,11,0,0,0-.026-22Z"
                transform="translate(-32 -112)" opacity="0.27" />
            </svg>
            <h4 [innerText]="options.message"></h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="options.uploadedFiles && options.uploadedFiles.length > 0">
      <div class="col-md-12 col-sm-12">
        <ul class="list-group mt-2">
          <li class="list-group-item align-left" *ngFor="let item of options.uploadedFiles; let idx = index">
            <div class="mb-2">
              {{item.fileName}}
              <span class="trash-btn-container mb-2">
                <span *ngIf="!item.isDone">{{item.progress}}%</span>
                <a (click)="onRemoveFile(idx)" class="btn btn-primary mt-2" *ngIf="item.isDone">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                    <path id="Path_53" data-name="Path 53"
                      d="M22,6.167a1.056,1.056,0,0,1-1.056,1.056H4.056a1.056,1.056,0,0,1,0-2.111H9.333V4.583A1.583,1.583,0,0,1,10.917,3h3.167a1.583,1.583,0,0,1,1.583,1.583v.528h5.278A1.056,1.056,0,0,1,22,6.167Z"
                      transform="translate(-3 -3)" fill="#ffffff" />
                    <path id="Path_54" data-name="Path 54"
                      d="M5.5,9V19.028a2.639,2.639,0,0,0,2.639,2.639h8.444a2.639,2.639,0,0,0,2.639-2.639V9Zm5.806,8.444a1.056,1.056,0,1,1-2.111,0V13.222a1.056,1.056,0,1,1,2.111,0Zm4.222,0a1.056,1.056,0,0,1-2.111,0V13.222a1.056,1.056,0,0,1,2.111,0Z"
                      transform="translate(-2.861 -2.667)" fill="#ffffff" />
                  </svg>
                </a>
              </span>
            </div>
            <mat-progress-bar [value]="item.progress" *ngIf="!item.isDone"></mat-progress-bar>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" (click)="onConfirm()" class="btn btn-default btn-action">Done</button>
  <button type="button" (click)="onClose()" class="btn btn-default btn-action btn-cancel"
    data-bs-dismiss="modal">Cancel</button>
</div>
